import type { Debugger } from 'debug';
import Debug from 'debug';

/**
 * Get debug logger, log will go to STDOUT
 * check more in "debug"
 */
export function getDebugLogger(namespace: string): Debugger {
  const debug = Debug(namespace);
  debug.log = console.log.bind(console);
  return debug;
}
